// src/pages/LandingPage.js
//
// Pass hosting/UX — a minimal, polished public front-door at "/". Not a marketing site: Motus wordmark, one
// headline, a short line, and clear CTAs into sign-in / create-account. Same visual language as the auth
// screens (real SAS Niseko photography under a dark gradient). Authenticated users are routed to their
// canonical dashboard by the route wrapper, so they never land here.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import MotusLogo from '../components/shared/MotusLogo';
import { PRODUCT_NAME } from '../config/product';
import { AUTH_T as T } from '../components/auth/AuthShell';

const HERO = "image-set(url('/assets/sas-hero.webp') type('image/webp'), url('/assets/sas-hero.jpg') type('image/jpeg'))";
const HERO_FALLBACK = "url('/assets/sas-hero.webp'), url('/assets/sas-hero.jpg')";

export default function LandingPage() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', position: 'relative', overflow: 'hidden', background: '#12100F', fontFamily: T.f, color: '#fff' }}>
      <style>{`
        .landing-img{position:absolute;inset:0;background-position:center;background-size:cover;
          background-image:${HERO_FALLBACK};background-image:${HERO};}
        .landing-grad{position:absolute;inset:0;background:
          linear-gradient(180deg,rgba(12,16,26,0.62),rgba(10,12,18,0.86)),
          radial-gradient(120% 80% at 12% 8%, rgba(37,99,235,0.30), transparent 55%);}
        .landing-inner{position:relative;min-height:100vh;display:flex;flex-direction:column;
          padding:40px 6vw;box-sizing:border-box;}
        .landing-cta{display:flex;gap:12px;flex-wrap:wrap;margin-top:26px;}
      `}</style>
      <div className="landing-img" />
      <div className="landing-grad" />
      <div className="landing-inner">
        <MotusLogo width={140} variant="dark" />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: 640 }}>
          <h1 style={{ fontFamily: T.fD, fontSize: 'clamp(34px, 6vw, 60px)', lineHeight: 1.04, fontWeight: 800, margin: '0 0 16px', letterSpacing: 0.2 }}>
            One platform for sports coaching and operations.
          </h1>
          <p style={{ fontSize: 'clamp(15px, 2vw, 18px)', lineHeight: 1.6, color: 'rgba(255,255,255,0.86)', maxWidth: 520, margin: 0 }}>
            Run the day, deliver better lessons, and keep every client relationship moving — in one place.
          </p>
          <div className="landing-cta">
            <button type="button" data-testid="landing-signin" onClick={() => navigate('/login')}
              style={{ padding: '13px 26px', fontSize: 15, fontWeight: 700, fontFamily: T.f, color: '#fff', background: T.blue, border: 'none', borderRadius: 11, cursor: 'pointer' }}>Sign in</button>
            <button type="button" data-testid="landing-getstarted" onClick={() => navigate('/signup')}
              style={{ padding: '13px 26px', fontSize: 15, fontWeight: 700, fontFamily: T.f, color: '#fff', background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.35)', borderRadius: 11, cursor: 'pointer' }}>Get started</button>
          </div>
        </div>
        <div style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.55)' }}>© {PRODUCT_NAME}</div>
      </div>
    </div>
  );
}
